import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import luxuryStartImg from "../../components/Main/Landing/images/luxury_start.png";

const useStyles = makeStyles((theme) => ({
  section: {
    maxWidth: '1314px',
    margin: '80px auto 10px',
    padding: '60px 21px 0',
    [theme.breakpoints.down('sm')]: {
      margin: '0px auto 10px',
      padding: '30px 21px 0',
    }
  },
  ctaContainer: {
    background: 'linear-gradient(90deg, #CE949C 0%, #E6B1BD 17.31%, #FFD0E1 36.06%, #CE949C 100%)',
    borderRadius: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 60px',
    position: 'relative',
    height: 326,
    maxHeight: 326,
    overflow: 'visible',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: '40px 24px 0',
      textAlign: 'center',
      height: 622,
      maxHeight: 622,
      overflow: 'hidden',
    }
  },
  ctaContent: {
    maxWidth: 520,
    zIndex: 2,
    padding: '0',
    [theme.breakpoints.down('sm')]: {
      padding: '0',
      marginBottom: '0px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }
  },
  ctaTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '52px',
    fontWeight: 400,
    lineHeight: '100%',
    color: '#111111',
    marginBottom: '16px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '36px',
      lineHeight: '100%',
    }
  },
  ctaSubtitle: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#111111',
    marginBottom: '24px',
    // opacity: 0.9,
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      lineHeight: '21px',
    }
  },
  buttonRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
      gap: '12px',
    }
  },
  btnMember: {
    backgroundColor: '#FD3C84',
    color: '#ffffff',
    padding: '12px 28px',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: 600,
    border: 'none',
    fontFamily: "'Roboto', sans-serif",
    cursor: 'pointer',
    boxShadow: '0 4px 14px rgba(253, 60, 132, 0.3)',
    transition: 'transform 0.2s, background-color 0.2s',
    height: '48px',
    [theme.breakpoints.down('sm')]: {
      width: '80%',
      height: '38px',
      padding: '7px 28px',
    },
    '&:hover': {
      transform: 'translateY(-1px)',
      backgroundColor: '#ff4081',
    }
  },
  btnCreator: {
    backgroundColor: 'transparent',
    color: '#FE5A97',
    padding: '12px 28px',
    height: '48px',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: 600,
    border: '1px solid #FE5A97',
    fontFamily: "'Roboto', sans-serif",
    cursor: 'pointer',
    transition: 'transform 0.2s, background-color 0.2s',
    [theme.breakpoints.down('sm')]: {
      width: '80%',
      height: '38px',
      padding: '7px 28px',
    },
    '&:hover': {
      transform: 'translateY(-1px)',
      backgroundColor: 'rgba(254, 90, 151, 0.08)',
    }
  },
  ctaImageContainer: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    width: '540px',
    height: '420px',
    zIndex: 1,
    pointerEvents: 'none',
    [theme.breakpoints.down('md')]: {
      width: '460px',
    },
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '405px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end',
    }
  },
  ctaImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    objectPosition: 'bottom right',
    display: 'block',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      objectFit: 'contain',
      objectPosition: 'bottom center',
    }
  }
}));

export const LifestyleJourneyCTASection = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Box className={classes.section}>
      <Box className={classes.ctaContainer}>
        <Box className={classes.ctaContent}>
          <Typography className={classes.ctaTitle}>
            Start Your Journey
          </Typography>
          <Typography className={classes.ctaSubtitle}>
            Whether you're looking to discover exclusive lifestyle content or share your own, your journey starts here.
          </Typography>

          <Box className={classes.buttonRow}>
            <button className={classes.btnMember} onClick={() => history.push('/member-onboarding-step')}>
              Request Member Access
            </button>
            <button className={classes.btnCreator} onClick={() => history.push('/apply-as-creator')}>
              Apply As Creator
            </button>
          </Box>
        </Box>

        <Box className={classes.ctaImageContainer}>
          <img
            src={luxuryStartImg}
            alt="Start Your Journey"
            className={classes.ctaImage}
          />
        </Box>
      </Box>
    </Box>
  );
};
